import React, { useEffect, useState } from 'react'
import { List, Space } from 'antd'
import { BulbOutlined } from '@ant-design/icons'
import SoftCourseDesc from './SoftCourseDesc'
import { useBnsJiaoChengListQuery } from '../store/ReactWebSiteApi'

function SoftCourseList(props) {
    const [list, setList] = useState([])
    const { data, isSuccess } = useBnsJiaoChengListQuery(
        {
            bjc_e_id: '218',
            bjc_bgn_id: props.bjc_bgn_id,
        },
        {
            refetchOnMountOrArgChange: 1,
            skip: !props.bjc_bgn_id,
        }
    )
    useEffect(() => {
        if (isSuccess) {
            if (data.Status === 'success') {
                const newArr = data.Result.map((item) => {
                    const {
                        bjc_id: key,
                        bjc_name,
                        bjc_ctime,
                        bjc_cname,
                        bjc_content,
                        bjc_dept_id,
                        bjc_dept_name,
                        bjc_bg_name,
                        bjc_bgn_name,
                        keshi,
                    } = item
                    return { ...item, key, bjc_name, bjc_ctime, bjc_cname, bjc_content, bjc_dept_id, bjc_dept_name, bjc_bg_name, bjc_bgn_name, keshi }
                })
                const sortArr = newArr.sort((a, b) => {
                    const aTime = new Date(a.bjc_ctime).getTime()
                    const bTime = new Date(b.bjc_ctime).getTime()
                    return bTime - aTime
                })
                setList(sortArr)
            } else {
                setList([])
            }
        }
    }, [data, isSuccess])
    return (
        <div style={{ padding: '8px 4px' }}>
            {list.map((item) => {
                let arr = []
                if (item.keshi) {
                    arr = item.keshi.map((k) => (
                        <SoftCourseDesc
                            key={k.bjcks_id}
                            bjcks_id={k.bjcks_id}
                            bjcks_name={k.bjcks_name}
                            bjcks_content={k.bjcks_content}
                        />
                    ))
                } else {
                    arr = '123'
                }
                return (
                    <div key={item.key}>
                        <Space>
                            <BulbOutlined /> {item.bjc_name}
                        </Space>
                        <List>{arr}</List>
                    </div>
                )
            })}
        </div>
    )
}

export default SoftCourseList
